import {_} from 'lodash';
import * as ko from "knockout";
import {IMessageData, ISyncField} from '../../../../index';
import {ObjectTypeId} from "../../../../constants";
import {createErrorMessage} from "../../../../util/misc";
import {nsSyncFields} from "../../../../req/nsSyncFields";
import {IRequestObject} from "../../../../req/index";
import {IDialogOptions} from "../../../dialog/index";
import syncfieldHtml from './syncfield.html?raw';

export let template = syncfieldHtml;

interface IParams {
    dialog: IDialogOptions
    filterFn?: (syncfield: ISyncField) => boolean
    sortFn?: (syncfield: ISyncField) => string
    callback: (syncfield: ISyncField) => void
    objectTypeId: ObjectTypeId
}

export class viewModel {
    private messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    private data!: ISyncField[];
    private getSyncfields!: IRequestObject

    constructor(private params: IParams) {
        this.init();
    }

    private init() {
        this.isReady(false);
        this.getSyncfields = nsSyncFields.getSyncFields(this.params.objectTypeId);
        this.getSyncfields
            .request
            .then((data: ISyncField[]) => {
                this.data = _(data)
                    .filter(this.params.filterFn ?? Boolean)
                    .sortBy(this.params.sortFn ?? 'name')
                    .value() as ISyncField[];
                this.isReady(true);
            })
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)));
            });
    }

    private onRowClick(syncfield: ISyncField) {
        this.params.callback(syncfield);
        this.params.dialog.doClose?.();
    }

    protected onRowKeyUp = (syncfield: ISyncField, event: KeyboardEvent) => {
        if (event.key == 'Enter') {
            this.onRowClick(syncfield);
        }
    };

    dispose() {
        this.getSyncfields.promise.abort();
    }
}
